module.exports = __webpack_public_path__ + "static/img/istock-917895690_mod.7cac224.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/istock-917895690_mod.png
// module id = 1743
// module chunks = 5